import { createNode } from '@glueapp/graph-types';
import { Temporal } from '@js-temporal/polyfill';

export const SystemTimezone = createNode({
    id: 'System Timezone',
    name: 'System Timezone',
    description: 'Returns the system timezone identifier (e.g. "America/New_York")',
    aiDescription: 'Takes no inputs and outputs the system timezone identifier string (e.g. "America/New_York") on the "Timezone" port.',
    category: 'Date & Time',
    color: '#3b82f6',
    integration: undefined,
    inPorts: {},
    outPorts: {
        Timezone: { kind: 'string' },
    },
    execute: function () {
        return { output: { Timezone: Temporal.Now.timeZoneId() } };
    },
});
